// extracted by mini-css-extract-plugin
export default {"gallery":"Zm7jl ZdH1P","slide":"qLzQD"};